/* ==========================================================================
   SearcherPackagesFerry > Transactions
   ========================================================================== */
const storedRouteData = {};

function isEmpty(value) {
    if (value === null || value.trim() === '') return true;
    return false;
}

function getPorts(instance, callback) {
    const xhrCall = new XMLHttpRequest();

    const company = instance.element.getAttribute('data-company');
    const portsUrl = isEmpty(company) ? getPortsUrl(instance) : getPortsCompanyUrl(instance);

    xhrCall.open('GET', portsUrl, true);
    xhrCall.send();
    xhrCall.onreadystatechange = function s() {
        if (xhrCall.readyState === XMLHttpRequest.DONE) {
            if (xhrCall.status === 200) {
                const ports = JSON.parse(xhrCall.response);
                callback(ports, instance);
            }
        }
    };
}

function getPortsUrl(instance) {
    // TODO: Get values through model
    const ferriesUrl = '/ferriesShowcase/Shima/GetPorts';
    return `${ferriesUrl}${getUrlParams(instance)}`;
}

function getUrlParams(instance) {
    const portCode = instance.location[0].value;
    const application = instance.element.getAttribute('data-application');
    return `?portCode=${portCode}&application=${application}`;
}

function getPortsCompanyUrl(instance) {
    // TODO: Get values through model
    const ferriesUrl = instance.config.endpoint
        ? instance.config.endpoint.destinations
        : '/ferriesShowcase/Shima/GetPortsCompany';
    return `${ferriesUrl}${getPortsCompanyUrlParams(instance)}`;
}

function getPortsCompanyUrlParams(instance) {
    const portCode = instance.location[0].value;
    const application = instance.element.getAttribute('data-application');
    const company = instance.element.getAttribute('data-company');
    return `?portCode=${portCode}&application=${application}&companyCode=${company}`;
}

function getRouteData(instance, callback) {
    const cachedRs = storedRouteData[getLocationsKey(instance.location)];
    if (cachedRs === undefined) {
        const xhrCall = new XMLHttpRequest();
        xhrCall.open('GET', getRouteDataUrl(instance), true);
        xhrCall.send();
        xhrCall.onreadystatechange = function s() {
            if (xhrCall.readyState === XMLHttpRequest.DONE) {
                if (xhrCall.status === 200) {
                    const data = JSON.parse(xhrCall.response);
                    callback(data.data, instance);
                    storedRouteData[getLocationsKey(instance.location)] = data.data;
                }
            }
        };
    } else {
        callback(cachedRs, instance);
    }
}

function getRouteDataUrl(instance) {
    const ferriesUrl = '/ferriesShowcase/Shima/GetRouteData';
    return `${ferriesUrl}${getUrlRouteDataParams(instance)}`;
}

function getUrlRouteDataParams(instance) {
    const origin = instance.location[0].value;
    const [destinationPort] = instance.location[1].value.toString().split(',');
    const application = instance.element.getAttribute('data-application');
    const company = instance.element.getAttribute('data-company');
    const base = `?originPortCode=${origin}&destinationPortCode=${destinationPort}&application=${application}`;

    if (isEmpty(company)) {
        return base;
    }

    return `${base}&companyCode=${company}`;
}

function getLocationsKey(locations) {
    return `${locations[0].value}#${locations[1].value}`;
}

function getCachedRouteData(locations) {
    return storedRouteData[getLocationsKey(locations)];
}

module.exports = {
    getPorts,
    getRouteData,
    getCachedRouteData
};
